<div id="unlock" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">
  <app-wellcome />
  <div
    id="unlock-form-wrapper"
    fusePerfectScrollbar
    [@animate]="{ value: '*', params: { delay: '300ms', x: '100%' } }"
  >
    <form
      name="unlockForm"
      autocomplete="off"
      *ngIf="unlockForm"
      [formGroup]="unlockForm"
      (submit)="sendPinCode()"
      class="mat-flex"
      novalidate
    >
      <div id="unlock-form">
        <div class="title">DESBLOQUEAR CUENTA</div>
        <div *ngIf="step === registep.lock" class="message">
          <h4>{{ message }}</h4>
          <br />
          <br />
        </div>
        <div *ngIf="step === registep.securityPin" class="pin-code">
          <p>Ingrese su código pin por favor</p>
          <app-pin-code
            (pinCodeEmitter)="processPin($event)"
            [boardPinCode]="boardPinCode"
            [config]="pinCodeConfig"
          ></app-pin-code>
          <app-number-board
            (numberEmit)="receiveValue($event)"
          ></app-number-board>
        </div>
      </div>
      <div
        *ngIf="
          step === registep.securityPin && unlockForm.get('pinCode')?.valid
        "
      >
        <div fxLayoutAlign="center">
          <button
            mat-raised-button
            color="primary"
            class="submit-button w-button"
            aria-label="CREATE AN ACCOUNT"
            [disabled]="unlockForm.invalid || isLoading"
          >
            <span *ngIf="!isLoading">Validar</span>
            <div class="loadingComponent" *ngIf="isLoading">
              <app-loading [isLoading]="isLoading" />
            </div>
          </button>
        </div>
      </div>
      <div [hidden]="step != registep.emailSent" class="email-sent">
        <h4>Hemos enviado un email al siguiente correo electronico</h4>
        <h4>{{ email }}</h4>
        <div *ngIf="!isUserUnlock">
          <a (click)="sendPinCode()">Volver a enviar email</a>
        </div>
        <br />
        <br />
      </div>
    </form>
    <div fxLayoutAlign="center">
      <button
        mat-raised-button
        color="warn"
        *ngIf="showExitButton()"
        class="w-button"
        (click)="exit()"
      >
        Salir
      </button>
    </div>
    <div class="footer">Nubyy 2019, Todos los derechos reservados.</div>
  </div>
</div>
